import { forwardRef } from "react";
import * as React from "react";
import cn from "classnames";
import type { ButtonStyle } from "@ebsco-ui/button";

import "./hyperlink.scss";

type ButtonStyleTypes = "primary" | "passive" | "highlighted" | "pill";

export type HyperlinkStyle =
  | "underline"
  | "underline-without-focus-ring"
  | "title"
  | Extract<ButtonStyle, ButtonStyleTypes>;

export interface HyperlinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  showExternalLinkWarning?: boolean;
  externalLinkWarningText?: string;
  styleType?: HyperlinkStyle;
}

const Hyperlink = forwardRef<HTMLAnchorElement, HyperlinkProps>(
  (
    {
      children,
      onClick,
      showExternalLinkWarning = false,
      externalLinkWarningText = "(opens new window)",
      className = "",
      styleType = "underline",
      ...props
    },
    ref,
  ) => (
    <a
      data-auto="eb-hyperlink"
      className={cn("eb-hyperlink", `eb-hyperlink--${styleType}`, className)}
      rel="noopener noreferrer"
      onClick={(event) => onClick && onClick(event)}
      ref={ref}
      {...props}
    >
      {children}
      {showExternalLinkWarning && `${" "}${externalLinkWarningText}`}
    </a>
  ),
);

Hyperlink.displayName = "Hyperlink";

export default Hyperlink;
